import {Component, Input, OnInit, Optional, Self} from '@angular/core';
import {NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import { ComparableOperator, PosibleAnswer } from '@app/models/form';

export interface TableInputConfig {
  columns: {
    id: number,
    code: string;
    description: string;
  }[]
}

export interface TableInputColumnValue {
  [columnID: number]: string;
}

@Component({
  selector: 'app-table-input',
  templateUrl: './table-input.component.html',
  styleUrls: ['./table-input.component.scss']
})
export class TableInputComponent extends BaseAnswerTypeComponent<TableInputColumnValue[]> implements OnInit {
  @Input() maxLength: number = 200;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() inputType: 'text' | 'email' | 'number' = 'text';

  @Input()
  tableConfig: TableInputConfig;

  constructor(@Optional() @Self() ngControl?: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
  }


  writeValue(obj: any) {
    super.writeValue(obj);
  }

  updateList(row: TableInputColumnValue, columnCode: number, event: any) {
    if (!event. target?.textContent) {
      (event.target as HTMLSpanElement).textContent = '---';
    }
    row[columnCode] = event. target?.textContent;
    this.updateValue([...this.value]);
  }

  addRow() {
    this.updateValue([
      ...(this.value || []),
      this.tableConfig.columns.reduce((obj, coll) => {
        return {
          ...obj,
          [coll.code]: '---',
        }
      }, {}),
    ])
  }

  remove(row: TableInputColumnValue, rowIndex: number) {
    this.updateValue(this.value.filter((r, index) => index !== rowIndex));
  }

  selectText() {
    setTimeout(() =>
      document.execCommand('selectAll',false,null)
    )
  }

  AllowedOperators: {[K in ComparableOperator]: (target: TableInputColumnValue[], value: string) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: (t, value) => t?.length > +value,
    [ComparableOperator.GreaterThanOrEqual]: (t, value) => t?.length >= +value,
    [ComparableOperator.LessThan]: (t, value) => t?.length < +value,
    [ComparableOperator.LessThanOrEqual]: (t, value) => t?.length <= +value,
    [ComparableOperator.IsNullOrEmpty]: (t) => !(t?.length),
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t?.length,
    [ComparableOperator.Between]: null,
  }
}
